import { frontendURL } from '../../../helper/URLHelper';
import KanbanDashboard from './pages/KanbanDashboard.vue';

const permissions = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/kanban'),
      name: 'kanban_index',
      meta: { permissions },
      component: KanbanDashboard,
    },
  ],
};
